
import Map from 'ol/Map';
import * as ol_style from 'ol/style';
import Feature from 'ol/Feature';
import { Vector as ol_layer_Vector } from 'ol/layer';
import { Vector as ol_source_Vector } from 'ol/source';
import { Point as ol_geom_Point } from 'ol/geom';
import { Circle as CircleStyle, Fill, RegularShape, Stroke, Style, Text } from 'ol/style';
import {getTopLeft} from 'ol/extent';
import { OlMainComponent } from 'gmap';
import { MapStylesHelper } from 'gmap';
import { mapcte } from 'gmap';

export class MapFlightOverlay {

  map: Map;
  featureOverlay;
  collection = [];
  /**
   * Layers list where onmove is used
   */
  layersId:any[]=[];
  constructor(public mapc: OlMainComponent) {
    this.map = mapc.map;
    //mapc.onPointerMove.subscribe(res => this.onPointerMove(res));

    this.featureOverlay = new ol_layer_Vector({
      map: mapc.map,
      source: new ol_source_Vector({
        features: this.collection,
        useSpatialIndex: false // optional, might improve performance
      }),
      style: this.styleFunction.bind(this),
      updateWhileAnimating: true, // optional, for instant visual feedback
      updateWhileInteracting: true // optional, for instant visual feedback
    });
  }

  /**
   * Add the id of the layer that this can draw.
   * @param id 
   */
  addLayer(id){
    this.layersId.push(id);
  }
  /**
   * 
   * @param coordinate 
   * @param feature 
   * @param layer 
   */
  onPointerMove(coordinate, feature, layer){
    if (!this.featureOverlay) {
      return;
    }
    this.featureOverlay.getSource().clear();

    if (!layer){
      return;
    }
    const haslayer=this.layersId.find(item=> item==layer[mapcte.frlayerinfo_FieldName].id);
    if (!haslayer){
      return;
    }
    this.setFeature(coordinate, feature, layer);
  }

  setNoHit(){
    if (!this.featureOverlay) {
      return;
    }
    this.featureOverlay.getSource().clear();
  }

  setFeature(coordinate, feature, layer) {
    try {
      // check the layer property, if it is not set then it means we
      // are over an OverlayFeature and we can ignore this feature
      if (!layer) {
        return;
      }
      // test the feature's geometry type and compute a reasonable point
      // at which to display the text.
      const geometry = feature.getGeometry();
      let point;
      //console.log("geometry.getType()",geometry.getType());
      switch (geometry.getType()) {
        case 'MultiPolygon':
          const poly = geometry.getPolygons().reduce(function (left, right) {
            return left.getArea() > right.getArea() ? left : right;
          });
          point = poly.getInteriorPoint().getCoordinates();

          break;
        case 'Polygon':
          //point = geometry.getInteriorPoint().getCoordinates();
          //console.log(getTopLeft(geometry.getExtent()));
          //point = geometry.getFirstCoordinate();
          point=getTopLeft(geometry.getExtent());

          break;
        default:
          point = geometry.getClosestPoint(coordinate);
      }
      // create a new feature to display the text
      let textFeature = new Feature({ geometry: new ol_geom_Point(point), text: feature.frlayerinfo.name, id: feature.frlayerinfo.id});
      let featureHighLight = new Feature({ geometry: geometry, text: feature.frlayerinfo.name, id: feature.frlayerinfo.id});

      this.featureOverlay.getSource().addFeature(textFeature);
      this.featureOverlay.getSource().addFeature(featureHighLight);
    } catch (err) {
        console.log(err);
    }

  }
  // when we move the mouse over a feature, we can change its style to
  // highlight it temporarily
  highlightStyle: any = new ol_style.Style({
    stroke: new ol_style.Stroke({
      color: [255, 0, 0, 1],
      width: 1
    }),
/*     fill: new ol_style.Fill({
      color: [255, 0, 0, 0.2]
    }), */
    zIndex: 1
  });

  // the style function for the feature overlay returns
  // a text style for point features and the highlight
  // style for other features (polygons in this case)
  styleFunction(feature, resolution) {
    //console.log(feature);
    let style;
    let geom = feature.getGeometry();

    if (geom.getType() == 'Point') {
      let text = feature.get('text');
      style = new ol_style.Style({
        text: MapStylesHelper.baseStyleText(text),
/*         image: new ol_style.Icon({
          src: '../assets/ol/marker.svg'
          , scale: 1
        }), */
        zIndex: 2
      });
    } else {
      style = this.highlightStyle;
    }

    return [style];
  }


  


}